<template>
  <div>
    <el-form ref="form" :rules="rules" :model="form" class="login-form" auto-complete="on" label-position="left">
      <el-form-item prop="phone">
        <el-input v-model="form.phone" placeholder="手机号码" type="text" prefix-icon="el-icon-mobile-phone"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          style="width: 100%;"
          v-model="form.password"
          :type="passwordType"
          placeholder="登录密码"
          prefix-icon="el-icon-lock"
          tabindex="2"
          auto-complete="new-password"
          :name="`password${Math.floor(Math.random()*100000)}`"
        >
          <template slot="suffix">
            <span class="my-type-info my-p-l-20 my-p-r-20" @click="passwordType=passwordType === 'password'?'':'password'">
              <i class="el-icon-view"></i>
            </span>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="code">
        <div class="my-flex">
          <el-input v-model="form.code" placeholder="验证码" name="code" type="text" prefix-icon="el-icon-user-solid"></el-input>

          <div :class="['code-side',!isDefault ? 'code-side-default' : '']" @click="getCode">{{ codeName }}</div>
        </div>
      </el-form-item>
    </el-form>
    <el-button :loading="loading" type="primary" style="width:100%;" @click="handleSubmit" size="default">注册</el-button>
    <div style="text-align: center; margin-top: 10px;">
      <span style="font-size: 12px; color: #999;">点击「注册」表示你已阅读并同意遵守我们的</span>
      <agreement-dialog>
        <span style="font-size: 12px;color: #409EFF; cursor: pointer;">《服务协议》</span>
      </agreement-dialog>
    </div>
    <div class="my-flex my-row-right my-p-t-10">
      <span style="color:#C3C3C3">已有账号？</span>
      <el-link type="primary" :underline="false" @click="$emit('change')">去登录</el-link>
    </div>
  </div>
</template>
    
<script>
import API from '@/api/_common'
import API_User from '@/api/user'
import { setToken } from '@/utils/auth'
import AgreementDialog from '@/_myComponents/AgreementDialog'
export default {
  name: '',
  components: { AgreementDialog },
  props: {},
  data() {
    return {
      passwordType: 'password',
      form: {
        phone: '',
        code: '',
        password: ''
      },
      codeName: '获取验证码',
      isDefault: true,
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: ['change'] },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: ['change'] }
        ],
        password: [{ required: true, message: '请填写登录密码', trigger: 'change' }]
      },
      loading: false
    }
  },

  computed: {},
  created() {},
  methods: {
    countDown(num, that) {
      var remainTime = num
      var cacheTime = new Date().getTime()
      var timer = setInterval(function () {
        var currTime = new Date().getTime()
        var vanishTimie = Math.ceil(currTime - cacheTime) // 获得消失的时间
        var newRemainTime = parseInt(remainTime - vanishTimie / 1000)
        if (newRemainTime >= 1) {
          that.codeName = `重新获取(${newRemainTime}s)`
          that.isDefault = false
        } else {
          that.codeName = '获取验证码'
          that.isDefault = true
          clearInterval(timer)
        }
      }, 1000)
    },
    getCode() {
      this.$refs.form.clearValidate(['code'])
      const that = this
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.isDefault) {
            this.countDown(60, that)
            API.verifyCodeSend({ product: this.utils.getProductCode(), target: that.form.phone, type: 'Register' }).then()
          }
        }
      })
    },
    handleSubmit() {
      this.$refs.form.validateField(['code'])
      const that = this
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          API.register({
            product: this.utils.getProductCode(),
            account: that.form.phone,
            code: that.form.code,
            password: this.form.password,
            invite: '',
            from: 'Web'
          })
            .then(res => {
              this.loading = false
              console.log('register res', res)
              let username = res.data.username
              let passwordName = res.data.password || '(空)'
              let password = res.data.password
              this.$alert(`默认用户：${username}\r\n默认密码：${passwordName}\r\n登录后请及时修改`, '提示', {
                confirmButtonText: '立即登录',
                callback: () => {
                  API_User.login({
                    account: this.form.phone,
                    username: username,
                    password: password
                  })
                    .then(() => {
                      this.$Message({
                        showClose: true,
                        message: '登录成功',
                        type: 'success'
                      })
                      //b保存token
                      setToken(res.data)
                      //获取userInfo
                      API_User.getInfo({ refresh: true }).then(res => {
                        if (res.data.tenantAccount.toLowerCase() != 'demo') {
                          this.$store.dispatch('dataCache/setUserInfo', res.data)
                          //回调
                          this.$emit('confirm', res.data)
                        }
                      })
                    })
                    .catch(err => {
                      this.$Message({
                        showClose: true,
                        message: err.data.message,
                        type: 'error'
                      })
                    })
                }
              })
            })
            .catch(err => {
              this.loading = false
              console.log('register err', err)
              this.$Message({
                showClose: true,
                message: err.data.message,
                type: 'error'
              })
            })
        }
      })
    }
  }
}
</script>
    <style lang="scss" scoped>
.code-side {
  width: 25%;
  background: rgb(41, 173, 96);
  color: #fff;
  border-radius: 5px;
  margin-left: 10px;
  text-align: center;
  font-size: 12px;
  cursor: pointer;
}
.code-side-default {
  background: #666;
}
</style>
    